export const LOCAL_STORAGE_USER_TOKEN_KEY = "silphium_user_token";
export const LOCAL_STORAGE_USER_DATA_KEY = "silphium_user_data";
export const APP_NAME = "سيلفيوم";
